// Keyhint panel — hidden by default, toggled via ? or h. Closes on the
// same keys, on Esc, and on click outside the panel. Designed per
// project_keyhint_panel.md memory.
//
// The DOM and styling live in index.html (CSS uses the `hidden` attribute
// to control visibility); this module is just the toggle behaviour.
//
// Conflict avoidance: bail out of the keydown listener when a text input
// has focus, so typing 'h' in chat doesn't pop the panel. Same pattern
// keyboard.ts uses to gate tank input during chat.

export class Keyhint {
  constructor(private root: HTMLElement) {
    document.addEventListener('keydown', (e) => this.handleKey(e));
    document.addEventListener('pointerdown', (e) => this.handleClickOutside(e));
  }

  toggle(): void {
    this.root.toggleAttribute('hidden');
  }

  hide(): void {
    if (!this.root.hasAttribute('hidden')) this.root.setAttribute('hidden', '');
  }

  private handleKey(e: KeyboardEvent): void {
    if (isTextEditing(document.activeElement)) return;
    // ? lives on Shift+/ on US layouts; / and ? both toggle so the hint
    // panel opens whether or not the player holds Shift.
    if (e.key === '?' || e.key === '/' || e.key === 'h' || e.key === 'H') {
      this.toggle();
      e.preventDefault();
    } else if (e.key === 'Escape' && !this.root.hasAttribute('hidden')) {
      this.hide();
      e.preventDefault();
    }
  }

  private handleClickOutside(e: PointerEvent): void {
    if (this.root.hasAttribute('hidden')) return;
    if (e.target instanceof Node && this.root.contains(e.target)) return;
    this.hide();
  }
}

function isTextEditing(el: Element | null): boolean {
  if (!el) return false;
  if (el instanceof HTMLInputElement) return el.type === 'text' || el.type === 'search';
  if (el instanceof HTMLTextAreaElement) return true;
  return false;
}
